document.addEventListener("DOMContentLoaded", async () => {

    // Homepage only
    if (window.location.pathname !== "/") return;

    const popup = document.getElementById("sales-popup");
    if (!popup) return;

    const img = document.getElementById("sales-popup-img");
    const title = document.getElementById("sales-popup-title");
    const product = document.getElementById("sales-popup-product");
    const extra = document.getElementById("sales-popup-extra");
    const link = document.getElementById("sales-popup-link");
    const close = document.querySelector(".sales-popup-close");

    // -----------------------------
    // Cities
    // -----------------------------

    const cities = [

        "Ahmedabad","Surat","Vadodara","Rajkot","Bhavnagar","Jamnagar","Gandhinagar",

        "Jaipur","Jodhpur","Udaipur","Kota","Ajmer","Bikaner",

        "Delhi","New Delhi","Noida","Greater Noida","Ghaziabad","Gurugram","Faridabad",

        "Lucknow","Kanpur","Agra","Varanasi","Prayagraj","Meerut",

        "Mumbai","Pune","Nagpur","Nashik","Thane",

        "Indore","Bhopal","Jabalpur","Gwalior","Ujjain",

        "Hyderabad","Warangal","Karimnagar",

        "Bengaluru","Mysuru",

        "Kochi","Thiruvananthapuram","Kozhikode","Thrissur",

        "Kolkata","Howrah","Siliguri","Durgapur",

        "Chennai","Coimbatore","Madurai",

        "Vijayawada","Visakhapatnam",

        "Bhubaneswar","Cuttack",

        "Ludhiana","Amritsar",

        "Panipat","Ambala",

        "Patna","Muzaffarpur",

        "Raipur"

    ];

    // -----------------------------
    // Popup Headlines
    // -----------------------------

    const messages = [

        "🔥 Just Ordered",

        "📦 Recently Purchased",

        "⭐ Best Seller",

        "❤️ Loved by Artists",

        "🎉 Trending Now",

        "💖 Customer Favourite"

    ];

    let products = [];

    try {

        const response = await fetch("/collections/popular-products/products.json?limit=250");

        const data = await response.json();

        products = data.products.filter(product => product.images.length > 0);

    } catch (e) {

        console.error(e);

        return;

    }

    // -----------------------------
    // Weighted Products
    // -----------------------------

    const weightedProducts = [];

    products.forEach(product => {

        const tags = product.tags.map(tag => tag.toLowerCase());

        // Resin (Highest Priority)
        if (tags.includes("resin")) {

            weightedProducts.push(
                product, product, product,
                product, product, product
            );

        }

        // DIY Moulds
        else if (

            tags.includes("diy") ||

            tags.includes("mould") ||

            tags.includes("silicone")

        ) {

            weightedProducts.push(

                product, product,

                product, product

            );

        }

        // Pipe Cleaner

        else if (

            tags.includes("pipe") ||

            tags.includes("teddy")

        ) {

            weightedProducts.push(

                product,

                product

            );

        }

        // Candle

        else if (

            tags.includes("candle")

        ) {

            weightedProducts.push(

                product,

                product

            );

        }

        else {

            weightedProducts.push(product);

        }

    });

    function random(min, max) {

        return Math.floor(Math.random() * (max - min + 1)) + min;

    }

    let lastProduct = "";

    function showPopup() {

        const sourceProducts = weightedProducts.length
            ? weightedProducts
            : products;

        let p;

        do {

            p = sourceProducts[
                random(0, sourceProducts.length - 1)
            ];

        } while (

            sourceProducts.length > 1 &&

            p.handle === lastProduct

        );

        lastProduct = p.handle;

        img.src = p.images[0].src;

        product.textContent = p.title;

        link.href = "/products/" + p.handle;

        title.textContent =
            messages[random(0, messages.length - 1)];

        const qty = random(1,3);

        extra.innerHTML =
            "📍 " +
            cities[random(0,cities.length-1)] +
            " • " +
            qty +
            " item" +
            (qty > 1 ? "s" : "") +
            " • " +
            random(2,18) +
            " min ago";

        popup.classList.remove("hidden");

        popup.classList.add("show");

        setTimeout(() => {

            popup.classList.remove("show");

            setTimeout(() => {

                popup.classList.add("hidden");

            },400);

        },7000);

    }

    // First popup after 5 sec

    setTimeout(() => {

        showPopup();

        // Second popup after 40 sec

        setTimeout(() => {

            showPopup();

        },20000);

    },5000);

    close.onclick = () => {

        popup.classList.remove("show");

        setTimeout(() => {

            popup.classList.add("hidden");

        },400);

    };

});